import { TableBody } from '@razorpay/blade/components';
import { SalaryStructure } from 'components/SalaryStructure/types';
import React from 'react';
import SalaryStructuresListTableRow from './SalaryStructuresListTableRow';
import { SalaryStructureDetails } from '../SalaryStructureDetails';
import { FormProvider } from 'forms';
import { SalaryStructureCreationFlow, SalaryStructureFormData } from '../creation';
import { useSalaryStructureDetailsView } from '../hooks';

interface TableContentProps {
  structures: SalaryStructure[];
  onViewDetails: (structureId: string) => void;
}

const SalaryStructuresListTableContent = ({
  structures,
  onViewDetails,
}: TableContentProps) => {
  const { structureId, isDetailsViewOpen, openDetailsView, closeDetailsView } =
    useSalaryStructureDetailsView();

  const [isEditOpen, setIsEditOpen] = React.useState(false);
  const closeEdit = () => setIsEditOpen(false);

  return (
    <>
      <TableBody>
        {structures.map((structure) => (
          <SalaryStructuresListTableRow
            key={structure.id}
            structure={structure}
            onViewDetails={() => {
              openDetailsView(structure.id);
            }}
          />
        ))}
      </TableBody>
      <FormProvider initialState={{ isEditTemplateMode: true } as SalaryStructureFormData}>
        <SalaryStructureDetails
          isDrawerOpen={isDetailsViewOpen}
          closeDrawer={closeDetailsView}
          structureId={structureId}
          onEdit={() => setIsEditOpen(true)}
        />
        <SalaryStructureCreationFlow isOpen={isEditOpen} onClose={closeEdit} />
      </FormProvider>
    </>
  );
};

export default SalaryStructuresListTableContent;
